import { chiara } from "@/constants/artists/chiara";
import { emilio } from "@/constants/artists/emilio";
import { hana } from "@/constants/artists/hana";
import { josh } from "@/constants/artists/josh";
import { sam } from "@/constants/artists/sam";
import { ShowcaseSong } from "@/types/defs/conversionShowcase";

export const SHOWCASE_ARTISTS = [chiara, emilio, hana, josh, sam] as const;

export const BAR_COUNT = 32;
export const FFT_SIZE = 4096;
export const MIN_FREQ = 60;
export const MAX_FREQ = 5000;

export const SHOWCASE_SONGS = [
  {
    label: "middle of the night",
    url: "/audio/content/conversion-showcase/middle-of-the-night/middle-of-the-night.mp3",
    conversions: {
      [chiara.id]:
        "/audio/content/conversion-showcase/middle-of-the-night/middle-of-the-night-chiara.mp3",
      [emilio.id]:
        "/audio/content/conversion-showcase/middle-of-the-night/middle-of-the-night-emilio.mp3",
      [hana.id]:
        "/audio/content/conversion-showcase/middle-of-the-night/middle-of-the-night-hana.mp3",
      [josh.id]:
        "/audio/content/conversion-showcase/middle-of-the-night/middle-of-the-night-josh.mp3",
      [sam.id]:
        "/audio/content/conversion-showcase/middle-of-the-night/middle-of-the-night-sam.mp3",
    },
  },
  {
    label: "stand my ground",
    url: "/audio/content/conversion-showcase/stand-my-ground/stand-my-ground.mp3",
    conversions: {
      [chiara.id]:
        "/audio/content/conversion-showcase/stand-my-ground/stand-my-ground-chiara.mp3",
      [emilio.id]:
        "/audio/content/conversion-showcase/stand-my-ground/stand-my-ground-emilio.mp3",
      [hana.id]:
        "/audio/content/conversion-showcase/stand-my-ground/stand-my-ground-hana.mp3",
      [josh.id]:
        "/audio/content/conversion-showcase/stand-my-ground/stand-my-ground-josh.mp3",
      [sam.id]:
        "/audio/content/conversion-showcase/stand-my-ground/stand-my-ground-sam.mp3",
    },
  },
  {
    label: "tell the truth",
    url: "/audio/content/conversion-showcase/tell-the-truth/tell-the-truth.mp3",
    conversions: {
      [chiara.id]:
        "/audio/content/conversion-showcase/tell-the-truth/tell-the-truth-chiara.mp3",
      [emilio.id]:
        "/audio/content/conversion-showcase/tell-the-truth/tell-the-truth-emilio.mp3",
      [hana.id]:
        "/audio/content/conversion-showcase/tell-the-truth/tell-the-truth-hana.mp3",
      [josh.id]:
        "/audio/content/conversion-showcase/tell-the-truth/tell-the-truth-josh.mp3",
      [sam.id]:
        "/audio/content/conversion-showcase/tell-the-truth/tell-the-truth-sam.mp3",
    },
  },
  {
    label: "lie with you",
    url: "/audio/content/conversion-showcase/lie-with-you/lie-with-you.mp3",
    conversions: {
      [chiara.id]:
        "/audio/content/conversion-showcase/lie-with-you/lie-with-you-chiara.mp3",
      [emilio.id]:
        "/audio/content/conversion-showcase/lie-with-you/lie-with-you-emilio.mp3",
      [hana.id]:
        "/audio/content/conversion-showcase/lie-with-you/lie-with-you-hana.mp3",
      [josh.id]:
        "/audio/content/conversion-showcase/lie-with-you/lie-with-you-josh.mp3",
      [sam.id]:
        "/audio/content/conversion-showcase/lie-with-you/lie-with-you-sam.mp3",
    },
  },
  {
    label: "your love",
    url: "/audio/content/conversion-showcase/your-love/your-love.mp3",
    conversions: {
      [chiara.id]:
        "/audio/content/conversion-showcase/your-love/your-love-chiara.mp3",
      [emilio.id]:
        "/audio/content/conversion-showcase/your-love/your-love-emilio.mp3",
      [hana.id]:
        "/audio/content/conversion-showcase/your-love/your-love-hana.mp3",
      [josh.id]:
        "/audio/content/conversion-showcase/your-love/your-love-josh.mp3",
      [sam.id]:
        "/audio/content/conversion-showcase/your-love/your-love-sam.mp3",
    },
  },
] satisfies ShowcaseSong[];

// Initial selection for the conversion demo
export const INITIAL_SHOWCASE_SONG = SHOWCASE_SONGS[0];
export const INITIAL_SHOWCASE_ARTIST = SHOWCASE_ARTISTS[2];
